import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';
import {IP, Token, Usuario, defaultUsuario} from '../interface/usuario';
import {PoStorageService} from '@po-ui/ng-storage';
import { AuthUserPreferences } from '../auth/interface/auth-user-preferences';
import { UtilService } from './util';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  url: string;


  constructor(
    private http: HttpClient,
    private poStorageService: PoStorageService,
    private utilService: UtilService,
  ) {
    this.url = `${environment.urlApiProtheus}`;
  }

  login(login: string, password: string): Observable<Token> {

    const httpOptions = {
      headers: new HttpHeaders(
        {
          'X-PO-Screen-Lock': 'true',
          'content-type': 'application/json',
          'grant_type' : 'password',
          'password': password,
          'username': `${login==='admin'?'':environment.dominioAD}${login}`
        }

      ),
      params: new HttpParams()
    };

    return this.http.post<Token>(`${this.url}/api/oauth2/v1/token`, {}, httpOptions);

  }

  refreshToken(refreshToken: string): Observable<Token> {
    return this.http.post<Token>(`${this.url}/api/oauth2/v1/token?grant_type=refresh_token&refresh_token=${refreshToken}`, {});
  }

  getUser(): Observable<Usuario> {
    return this.http.get<Usuario>(`${this.url}/wsruser/`);
  }

  async autoLogin(login: string, password: string): Promise<Token> {
    return new Promise((resolve, reject) => {
      this.login(login, password).subscribe(
        token => {
          resolve(token);
          localStorage.setItem('token', JSON.stringify({...token, last_token_refresh: new Date().getTime() / 1000}));
        }, (error) => {
          console.log(error);
          reject();
        }
      );
    });
  }


  async validaPrivilegio(permissao: Array<string>): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.poStorageService.get('usuario').then(usuario => {
        if (permissao && permissao.length) {
          // @ts-ignore
          // tslint:disable-next-line:max-line-length
          const aPermissao = usuario.APRIVILEGIO.filter(item => permissao.includes(item.CCODIGO));
          if (aPermissao && aPermissao.length) {
            resolve(true);
          } else {
            resolve(false);
          }
        } else {
          resolve(true);
        }
      });
    });
  }

  getUserProfileByChave(CUSRID: string, CCHAVE: string): Observable<AuthUserPreferences> {
    let httpOptions = this.utilService.filtrosHttpOptions({},false);
    return this.http.get<AuthUserPreferences>(`${this.url}/wsruser/profile/${CUSRID}/${CCHAVE}`,httpOptions);
  }

  postUserProfile(authUserPreferences: AuthUserPreferences): Observable<any> {
    let httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/wsruser/profile`, authUserPreferences, httpOptions );
  }

  async getUsuarioSessao(): Promise<Usuario> {
    return new Promise((resolve, reject) => {
      this.poStorageService.get('usuario').then(usuario => {
        if (usuario){
          resolve(usuario);
        }else{
          resolve(defaultUsuario());
        }
      });
    });
  }

  getIP(): Observable<IP> {
    return this.http.get<IP>('https://api.ipify.org?format=json');
  }

}
